import { createContext, useContext, type Provider } from 'react';

export type UIConfig = {
	elements?: {
		agentsMenu?: boolean;
		browseAgentsButton?: boolean;
		createAgentButton?: boolean;
	};
};

const uiConfigContext = createContext<UIConfig>({});

export const useUIConfig = (): UIConfig => useContext(uiConfigContext);

export const UIConfigProvider: Provider<UIConfig> = uiConfigContext.Provider;
